import users from './users';
import agents from './agents';
import directories from './directories';
import files from './files';
import internationalization from './internationalization';
import administration from './administration';
import formBuilder from './formBuilder';
import lkkUserApi from './lkkUserApi';
import correspondentBanks from './correspondentBanks';
import processes from './processes';

export default {
  name: 'admin',
  path: '/admin',
  component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/index.vue'),
  children: [
    directories,
    files,
    users,
    administration,
    internationalization,
    formBuilder,
    agents,
    lkkUserApi,
    correspondentBanks,
    processes,
  ],
};
